import { render, staticRenderFns } from "./SummerNote.vue?vue&type=template&id=4c1440b6&"
import script from "./SummerNote.controller.js?vue&type=script&lang=js&"
export * from "./SummerNote.controller.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports